import React from 'react';
import { Link } from 'react-router-dom';
import Meta from './Meta';

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white" style={{ paddingTop: '80px' }}>
      <Meta
        title="ページが見つかりません | うのつのぶこ"
        description="お探しのページは見つかりませんでした。"
        canonical="https://unotsunobuko.com/404"
        robots="noindex, nofollow"
      />
      <h1 className="text-2xl font-bold mb-4" style={{ color: '#e3628d' }}>ページが見つかりません</h1>
      <p className="text-gray-600 mb-6">URLが間違っているか、ページが移動した可能性があります。</p>
      <Link to="/" className="btn">ホームに戻る</Link>
    </div>
  );
};

export default NotFound;


